
import Logo from '../Logo';

const AuthInfo = () => {
  return (
    <div className="h-full fixed top-0 left-0 pl-[130px] pr-[118px] pt-[159px] pb-[50px] text-white bg-[#044E97] lg:pr-[0.4px] lg:ml-[-3em] xl:ml-0 biglg:ml-0 2xl:ml-0 biglg:pr-[4em] xl:pr-[8em] 2xl:pr-[13em] ">
      <div
        className="auth-arrow top-[47%] right-[-15px] absolute w-[32px] h-[28px] bg-[#044E97]"
        style={{ clipPath: 'polygon(0 0, 100% 50%, 100% 50%, 0 100%)' }}
      ></div>
      <div className='flex justify-center'> 
      <Logo/>
      </div>
   
      <div className="pt-[85.36px] leading-[45px] text-[40px] font-bold w-[466px] ">
        <h1 className="font-family-sans  text-white">
          World Class Solutions for
          <h1 className=" text-[#FF6702]">Every Business.</h1>{' '}
        </h1>
      </div>

      <div className=" text-[16px] leading-[20px]  w-[375.3px]">
        <div className="flex mt-[51px]">
          {/*  Fancy hyphen created with divs */}
          <div className="pt-[14px] ">
            <div className="w-[18px] h-[18px] bg-[#11ABD1] "></div>
            <div className="w-[18px] h-[18px] bg-[#FF6702] mt-[-25px] ml-[5px]"></div>
          </div>

          <p className="  pl-[14px] ">
            <b>Visibility </b> - Get a detailed overview of your business by tracking activities.
          </p>
        </div>

        <div className="flex mt-[20px]">
          {/*  Fancy hyphen created with divs */}
          <div className="pt-[14px]">
            <div className="w-[18px] h-[18px] bg-[#11ABD1] "></div>
            <div className="w-[18px] h-[18px] bg-[#FF6702] mt-[-25px] ml-[5px]"> </div>
          </div>

          <p className=" pl-[11.6px] ">
            <b>Automation </b> - Save time and speed of business processes with easy-to-use integrated solutions.
          </p>
        </div>

        <div className="flex mt-[20px]">
          {/*  Fancy hyphen created with divs */}
          <div className="pt-[14px]">
            <div className="w-[18px] h-[18px] bg-[#11ABD1] "></div>
            <div className="w-[18px] h-[18px] bg-[#FF6702] mt-[-25px] ml-[5px]"> </div>
          </div>

          <p className="pl-[11.6px] ">
            <b>Manage Customers </b> - Build relationships with your customers with AI driven CRM.
          </p>
        </div>

        <div className="flex mt-[20px]">
          {/*  Fancy hyphen created with divs */}
          <div className="pt-[14px]">
            <div className="w-[18px] h-[18px] bg-[#11ABD1] "></div>
            <div className="w-[18px] h-[18px] bg-[#FF6702] mt-[-25px] ml-[5px]"> </div>
          </div>

          <p className=" pl-[11.6px] ">
            <b>Insights & Analytics. </b> - Get a detailed overview of your business by tracking tasks and staff.
          </p>
        </div>
      </div>
    </div>
  );
};

export { AuthInfo };
